/* import __COLOCATED_TEMPLATE__ from './procedure-channel-badge.hbs'; */
/* RESPONSIBLE TEAM: team-actions */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';

interface Signature {
  Args: {
    targetChannels?: string[] | null;
  };
}

const MAX_CHANNELS_BEFORE_OVERFLOW = 3;

export default class ProcedureChannelBadge extends Component<Signature> {
  @service declare intl: IntlService;

  get channels(): string[] {
    return this.args.targetChannels ?? [];
  }

  get hasChannels(): boolean {
    return this.channels.length > 0;
  }

  get label(): string {
    return this.channelsLabel;
  }

  private get channelsLabel(): string {
    let channels = this.channels;
    let visible = channels
      .slice(0, MAX_CHANNELS_BEFORE_OVERFLOW)
      .map((channel) => this.intl.t('operator.workflows.channels.type', { channel }))
      .join(', ');

    if (channels.length > MAX_CHANNELS_BEFORE_OVERFLOW) {
      return this.intl.t('standalone.tasks.list.your-processes.channel-badge.more', {
        channels: visible,
        count: channels.length - MAX_CHANNELS_BEFORE_OVERFLOW,
      });
    }

    return visible;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksAndProcedures::ProcedureChannelBadge': typeof ProcedureChannelBadge;
    'tasks-and-procedures/procedure-channel-badge': typeof ProcedureChannelBadge;
  }
}
